import { render } from "./TableTask_categories.vue?vue&type=template&id=94a6fda0&scoped=true"
import script from "./TableTask_categories.vue?vue&type=script&lang=js"
export * from "./TableTask_categories.vue?vue&type=script&lang=js"

import "./TableTask_categories.vue?vue&type=style&index=0&id=94a6fda0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a6fda0"]])

export default __exports__